export type ButtonThemes = 'danger' | 'darkPrimary' | 'disabled' | 'light' | 'lightDanger' | 'loading' | 'main' | 'primary' | 'secondary' | 'secondaryDanger' | 'forestGreen'

const themesMap = {
    danger: 'danger',
    darkPrimary: 'darkPrimary',
    disabled: 'disabled',
    light: 'light',
    lightDanger: 'lightDanger',
    loading: 'loading',
    main: 'main',
    primary: 'primary',
    secondary: 'secondary',
    secondaryDanger: 'secondaryDanger',
    forestGreen: 'forestGreen',
    yellow: 'yellow',
}

export const defaultTheme = 'primary'

export default themesMap
